export const poolQueryKeys = {
  all: ["pool"],
  list: (filters) => ["pool", "list", filters],
  detail: (id) => ["pool", "detail", id],
};
